import { createReducer, on } from '@ngrx/store';
import * as ShoppingListActions from './shopping-list.actions';
import { ShoppingListItemWithIngredient } from '../../../shared/models/shopping-list-item';
import { QuotaInfo } from '../../../shared/models/quota-info.model';
import { IngredientCategory } from '../../../shared/enums/ingredient-category.enum';

export interface ShoppingListState {
  items: ShoppingListItemWithIngredient[];
  isLoading: boolean;
  isShoppingQuotaLoading: boolean;
  error: any;
  searchTerm: string;
  filters: ShoppingListFilterMap;
  quota: QuotaInfo | null;
}

export interface ShoppingListFilterMap {
  category: IngredientCategory[];
  is_bought: boolean;
}

export const initialState: ShoppingListState = {
  items: [],
  isLoading: false,
  isShoppingQuotaLoading: false,
  error: null,
  filters: {
    category: [],
    is_bought: null
  },
  searchTerm: '',
  quota: null
};

export const shoppingListReducer = createReducer(
    initialState,
  
    // Load
    on(ShoppingListActions.loadShoppingListItems, state => ({ ...state, isLoading: true })),
    on(ShoppingListActions.loadShoppingListItemsSuccess, (state, { items }) => ({ ...state, isLoading: false, items })),
    on(ShoppingListActions.loadShoppingListItemsFailure, (state, { error }) => ({ ...state, isLoading: false, error })),

    on(ShoppingListActions.loadShoppingListQuota, state => ({ ...state, isShoppingQuotaLoading: true })),
    on(ShoppingListActions.loadShoppingListQuotaSuccess, (state, { quota }) => ({
      ...state,
      isShoppingQuotaLoading: false,
      quota
    })),
    on(ShoppingListActions.loadShoppingListQuotaFailure, (state) => ({
      ...state,
      quota: null,
      isShoppingQuotaLoading: false,
    })),
  
    // Add
    on(ShoppingListActions.addShoppingListItem, state => ({ ...state, isLoading: true })),
    on(ShoppingListActions.addShoppingListItemSuccess, (state, { item }) => ({ ...state, isLoading: false, items: [...state.items, item] })),
    on(ShoppingListActions.addShoppingListItemFailure, (state, { error }) => ({ ...state, isLoading: false, error })),
  
    // Update
    on(ShoppingListActions.updateShoppingListItem, state => ({ ...state, isLoading: true })),
    on(ShoppingListActions.updateShoppingListItemSuccess, (state, { item }) => ({
      ...state,
      isLoading: false,
      items: state.items.map(i => i.shopping_list_id === item.shopping_list_id ? item : i)
    })),
    on(ShoppingListActions.updateShoppingListItemFailure, (state, { error }) => ({ ...state, isLoading: false, error })),
  
    // Delete
    on(ShoppingListActions.deleteShoppingListItem, state => ({ ...state, isLoading: true })),
    on(ShoppingListActions.deleteShoppingListItemSuccess, (state, { id }) => ({
      ...state,
      isLoading: false,
      items: state.items.filter(i => i.shopping_list_id !== id)
    })),
    on(ShoppingListActions.deleteShoppingListItemFailure, (state, { error }) => ({ ...state, isLoading: false, error })),

    on(ShoppingListActions.clearBoughtShoppingListItems, state => ({ ...state, isLoading: true })),
    on(ShoppingListActions.clearBoughtShoppingListItemsSuccess, (state) => ({
      ...state,
      isLoading: false,
      items: state.items.filter(i => !i.is_bought)
    })),
    on(ShoppingListActions.clearBoughtShoppingListItemsFailure, (state, { error }) => ({
      ...state,
      isLoading: false,
      error
    })),
  
    on(ShoppingListActions.setShoppingListFilters, (state, { filters }) => ({
        ...state,
        filters
      })),
      
      on(ShoppingListActions.clearShoppingListFilters, (state) => ({
        ...state,
        filters: {
          category: [],
          is_bought: null
        }
      })),
      
      on(ShoppingListActions.resetShoppingListFilters, (state) => ({
        ...state,
        filters: {
          category: [],
          is_bought: null
        }
      })),
      
      on(ShoppingListActions.updateShoppingListSearchTerm, (state, { term }) => ({
        ...state,
        searchTerm: term
      })),
      
      on(ShoppingListActions.resetShoppingListSearchTerm, (state) => ({
        ...state,
        searchTerm: ''
      })),
      // Bulk Add
on(ShoppingListActions.bulkAddShoppingListItems, state => ({
  ...state,
  isLoading: true
})),
on(ShoppingListActions.bulkAddShoppingListItemsSuccess, (state, { items }) => ({
  ...state,
  isLoading: false,
  items: [...state.items, ...items]
})),
on(ShoppingListActions.bulkAddShoppingListItemsFailure, (state, { error }) => ({
  ...state,
  isLoading: false,
  error
})),
      
    // Reset
    on(ShoppingListActions.resetShoppingList, () => initialState)
  );
